module.exports = __webpack_public_path__ + "img/library-active.66eb47a1.png";